import React, { Component } from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import axios from 'axios';

class LetsGo extends Component {

  constructor(props) {
      super(props);
      this.state = {
        step: 0,
        firstName: "",
        lastName: "",
        email: "",
        businessName: "",
        phone: "",
        website: "",
        userName: "",
        password: "",
        confirmPassword: "",
        error: false,
        current_user_id: props.current_user_id,
        logo: "",
        terms: "",
        howToUse: "",
        sell: "",
        salePrice: "",
        selling: []

      }
      this.step1=this.step1.bind(this);
      this.updateFirstName=this.updateFirstName.bind(this);
      this.updateLastName=this.updateLastName.bind(this);
      this.updateEmail=this.updateEmail.bind(this);
      this.updateBusinessName=this.updateBusinessName.bind(this);
      this.updatePhone=this.updatePhone.bind(this);
      this.updateWebsite=this.updateWebsite.bind(this);
      this.updateUserName=this.updateUserName.bind(this);
      this.updatePassword=this.updatePassword.bind(this);
      this.confirmPassword=this.confirmPassword.bind(this);
      this.submitUser=this.submitUser.bind(this);
      this.addLogo=this.addLogo.bind(this);
      this.addTerms=this.addTerms.bind(this);
      this.howToUse=this.howToUse.bind(this);
      this.createWidget=this.createWidget.bind(this);
      this.addSell=this.addSell.bind(this);
      this.removeSelling=this.removeSelling.bind(this);
      this.addSellPrice=this.addSellPrice.bind(this);
      this.captureOffer=this.captureOffer.bind(this);
      this.submitOffer=this.submitOffer.bind(this);
    }

    componentWillMount () {
      function getQueryVariable(variable)
      {
             var query = window.location.search.substring(1);
             var vars = query.split("&");
             for (var i=0;i<vars.length;i++) {
                     var pair = vars[i].split("=");
                     if(pair[0] == variable){return pair[1];}
             }
             return(false);
      }
      let step = getQueryVariable("step");
      let error= getQueryVariable("?error");
      let code=getQueryVariable("code");
      let scope= getQueryVariable("scope");


      if(error=="access_denied") {
        this.setState({step: 2, error: true});

      }

      else if (step==3) {
        this.setState({step: 3, code: code, scope: scope});
        // axios.post('https://whispering-spire-75342.herokuapp.com/users/stripe', {
        //         params: {
        //      code
        //         }
        //       })
        //       .then(function (response) {
        //       this.setState({storeStatus: response});
        //       if (response.date==="success"){
        //       this.setState({step: 1, current_user_id: response.id});
        //       console.log(response);}
        //     }.bind(this))
        //       .catch(function (error) {
        //         console.log("server off");
        //         console.log(error);
        //         document.getElementById('createUser').classList.add("serverError");
        //       });
      }
      else {console.log("wrong query");}
      ;

    }

    removeSelling(event){
      var forSale=this.state.selling;
      var buttonClicked=event.target.id;
      forSale.splice(buttonClicked, 1);
      this.setState({selling: forSale});

    }
    captureOffer(){
      var salesItem=[this.state.sell, this.state.salePrice];
      var forSale=this.state.selling;
      forSale.push(salesItem);
      this.setState({sell: "", salePrice: ""});
      this.setState({selling: forSale});
      document.getElementById("offer-what").value="";
      document.getElementById("offer-price").value="";
    }
    addLogo(event){
      var picture=event.target.files[0];
      console.log(picture);
      this.setState({logo: picture});
    }

    addTerms(event){
      this.setState({terms: event.target.value})
    }

    howToUse(event){
      this.setState({howToUse: event.target.value})
    }

    createWidget(){
      var widgetPreview=document.getElementById('widget-container');
      var user=this.state.current_user_id;
      var widgetCode=document.getElementById('widget-code');
      widgetPreview.style.display="block";
      widgetCode.style.display="block";

      widgetPreview.innerHTML='<iframe className="widget-preview" height="800" width="480" src="https://www.giftcardsfast.com/store/?id='+user+' style="border: solid 1px #999999; background-color: transparent" frameborder="0" allowtransparency="true"></iframe>';

      widgetCode.value='<iframe height="800" width="480" src="https://www.giftcardsfast.com/store/?id='+user+' style="border: solid 1px #999999; background-color: transparent" frameborder="0" allowtransparency="true"></iframe>';


    }

    addSell(event){
      this.setState({sell: event.target.value})
    }

    addSellPrice(event){
      this.setState({salePrice: event.target.value})
    }


    submitOffer(){
      var offer={selling: this.state.selling, terms: this.state.terms, howToUse: this.state.howToUse, logo: this.state.logo, current_user_id: this.state.current_user_id};


      axios.post('https://whispering-spire-75342.herokuapp.com/offers/', {
              params: {
                offer
              }
            })
            .then(function (response) {
            this.setState({storeStatus: response});
            if (response.date==="success"){
            this.setState({step: 1});
            console.log(response);}
          }.bind(this))
            .catch(function (error) {
              console.log("server off");
              console.log(error);
              document.getElementById('step3-button').classList.add("serverError");
            });
    }

    step1 () {
      this.setState({step: 1});
    }

    updateFirstName(event) {
      this.setState({firstName: event.target.value})
    }

    updateLastName(event){
      this.setState({lastName: event.target.value})
    }

    updateEmail(event){
      this.setState({email: event.target.value})
    }

    updateBusinessName(event){
      this.setState({businessName: event.target.value})
    }

    updatePhone(event) {
      this.setState({phone: event.target.value})
    }

    updateWebsite(event){
      this.setState({website: event.target.value})
    }

    updateUserName(event){
      this.setState({userName: event.target.value})
    }

    updatePassword(event){
      this.setState({password: event.target.value})
    }

    confirmPassword(event){
      this.setState({confirmPassword: event.target.value})
    }

  submitUser(event) {
    event.preventDefault();
    // event.stopPropagation();
    // event.nativeEvent.stopImmediatePropagation();
    var user={
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      businessName: this.state.businessName,
      phone: this.state.phone,
      website: this.state.website,
      userName: this.state.userName,
      password: this.state.password,
    };

    if (this.state.password===this.state.confirmPassword && this.state.password!="") {

      axios.post('https://whispering-spire-75342.herokuapp.com/businesses', {
              params: {
                user
              }
            })
            .then(function (response) {
            this.setState({storeStatus: response});
            console.log(response);
            if (this.state.response !=="fail"){
              this.props.setCurrentUser(response.current_business);
            this.setState({step: 2, current_user_id: response.data.current_business});
            console.log(response);}
            else (document.getElementById('createUser').classList.add("creationError"))
          }.bind(this))
            .catch(function (error) {
              console.log("server off");
              console.log(error);
              document.getElementById('createUser').classList.add("serverError");
            });
    }
  else {
    this.setState({password: "", confirmPassword: ""});
    document.getElementById('field_pwd1').classList.add("error");
    document.getElementById('field_pwd2').classList.add("error");
  }
  }





  render() {
    var step;
    if (this.state.step===0) {
      step=(<div><div className="faster-holder">
        <p className="faster">A Better, Faster Giftcard Experience</p>
      </div>
        <div className="lets-go-holder">
          <button onClick={this.step1} className="lets-go">Get Started</button>
        </div></div>)
      }
    else if (this.state.step===1) {
      step=<Step1
      updateFirstName={this.updateFirstName}
      updateLastName={this.updateLastName}
      updateEmail={this.updateEmail}
      updateBusinessName={this.updateBusinessName}
      updatePhone={this.updatePhone}
      updateWebsite={this.updateWebsite}
      updateUserName={this.updateUserName}
      updatePassword={this.updatePassword}
      submitUser={this.submitUser}
      confirmPassword={this.confirmPassword}
      />
    }
    else if (this.state.step===2) {
      step=<Step2
      error={this.state.error}
      />
    }
    else {
      step=<Step3
      createWidget={this.createWidget}
      howToUse={this.howToUse}
      addTerms={this.addTerms}
      addLogo={this.addLogo}
      addSell={this.addSell}
      addSellPrice={this.addSellPrice}
      current_user_id={this.state.current_user_id}
      selling={this.state.selling}
      removeSelling={this.removeSelling}
      captureOffer={this.captureOffer}
      logo={this.state.logo}
      submitOffer={this.submitOffer}

      />
    }





    return (
      <div className="main">
        <h1 className="main-h1">Gift Cards...Fast!</h1>
        {step}
      </div>

    );
  }
}

export default LetsGo;



// WEBPACK FOOTER //
// ./src/letsGo.js